/*global google*/
import React, { useCallback } from 'react'
import { Marker } from '@react-google-maps/api'
import { PexMarkerProps } from './types'

const PexMarker = (props: PexMarkerProps) => {
    const onMarkerClick = useCallback((e: google.maps.MapMouseEvent) => {
        props.onClick(e, props.station)
    }, []);

    return (
        <Marker
            key={props.station.id}
            position={{
                lat: Number(props.station.lat),
                lng: Number(props.station.lng),
            }}
            visible={props.visible}
            icon={props.icon}
            clusterer={props.clusterer}
            animation={google.maps.Animation.DROP}
            onClick={onMarkerClick}
        ></Marker>
    )
}

// Only rerender marker when visible or icon has changed
const MemoizedPexMarker = React.memo(
    PexMarker,
    (props: PexMarkerProps, nextProps: PexMarkerProps) => {
        if (props.visible !== nextProps.visible) {
            return false;
        } else if (props.icon !== nextProps.icon) {
            return false;
        }
        return true;
    }
)

export default MemoizedPexMarker;
